import React from 'react';

const link = "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/"

const Player = React.forwardRef((props,ref) => (
      <div className="Player-bottom">
      <div className="iframe-player">
        <iframe AllowScriptAccess="always" ref={ref} title="soudcloud-player" id="iframe" width="100%" allow={props.autoplay} height="20" scrolling="no" frameborder="no"
          src={link + props.id + "&auto_play=true&inverse=false&color=%23ff5500"}>
        </iframe>
      </div>
      </div>
))

export default Player;


// WEBPACK FOOTER //
// ./src/components/Player.js